import {defineComponent, PropType} from '@vue/composition-api';
import $ from 'jquery';

export enum SlideType {

    vertical,

    horizontal,

    both
}

export default defineComponent({

    props: {

        slideType: {

            required: false,

            type: Number as PropType<SlideType>,

            default: SlideType.vertical
        },

        duration: {

            required: false,

            type: Number,

            default: 350
        },

        delay: {

            required: false,

            type: Number,

            default: 50
        },

        tag: {
            required: false,

            type: String,

            default: 'div'
        }
    },

    setup(props) {

        const properties = (animateType: string) => {

            const v = props.slideType === SlideType.vertical || props.slideType === SlideType.both;

            const h = props.slideType === SlideType.horizontal || props.slideType === SlideType.both;

            return {
                width: h ? animateType : undefined,
                height: v ? animateType : undefined
            }
        }

        const enter = (element: HTMLElement, done: (this: HTMLElement) => void) => {

            return $(element).hide().delay(props.delay * $(element).index()).animate(properties('show'), props.duration, done);
        };

        const leave = (element: HTMLElement, done: (this: HTMLElement) => void) => {

            return $(element).delay(props.delay * $(element).index()).animate(properties('hide'), props.duration, done);
        };

        return {

            enter,

            leave
        }
    }
});
